import * as types from './actionTypes';
import {ajaxCallError} from './ajaxStatusActions';
import {Api} from '../api/Api';
import {beginAjaxCall} from './ajaxStatusActions';




export function getCursoConstanciaListSuccess(cursoconstancia) {
  return {type: types.LOAD_CURSOCONSTANCIA_LIST_SUCCESS, cursoconstancia};
}



export function getCursoConstanciaList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token) {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().CursoConstanciaApi.getCursoConstanciaList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token).then(cursoconstancia => {                  
                  dispatch(getCursoConstanciaListSuccess(cursoconstancia));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}



export function getCursoConstanciaSuccess(catalogo) {
  return {type: types.LOAD_CURSOCONSTANCIA_SUCCESS, catalogo};
}

export function getCursoConstancia(id, token) {
    return dispatch => {
        dispatch(beginAjaxCall());  
        return Api().CursoConstanciaApi.getCursoConstancia(id, token).then(cursoconstancia => {   
        dispatch(getCursoConstanciaSuccess(cursoconstancia));
        return cursoconstancia;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function saveSuccess(cursoconstancia) {
  return {type: types.SAVE_CURSOCONSTANCIA_SUCCESS, cursoconstancia};
}


export function save(cursoconstancia, token) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().CursoConstanciaApi.save(cursoconstancia, token).then(cursoconstanciaGuardado => {   
        dispatch(saveSuccess(cursoconstanciaGuardado));
        return cursoconstanciaGuardado;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}

export function saveImagenFondoImage(file, token) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().CursoConstanciaApi.saveImagenFondoImage(file, token).then(imagenGuardado => {
    dispatch(saveSuccess(imagenGuardado));
    return imagenGuardado;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}


export function saveImagenFirmaImage(file, token) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().CursoConstanciaApi.saveImagenFirmaImage(file, token).then(imagenFirmaGuardado => {
    dispatch(saveSuccess(imagenFirmaGuardado));
    return imagenFirmaGuardado;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}



export function getCursoConstanciaComboSuccess(datos) {
  return {type: types.GET_CURSOCONSTANCIAS_COMBO_SUCCESS, datos};
}

export function getCursoConstanciaCombo(token) {
    
  return dispatch => {
     
	dispatch(beginAjaxCall());  
      
    return Api().CursoConstanciaApi.getCursoConstanciaCombo(token).then(datos => {   
        
      dispatch(getCursoConstanciaComboSuccess(datos));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}

export function borrarSuccess(cursoconstancia) {
  return {type: types.BORRAR_CURSOCONSTANCIA_SUCCESS, cursoconstancia};
}


export function borrar(id, token ) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().CursoConstanciaApi.borrar(id, token ).then(cursoconstancia => {
               
                  dispatch(borrarSuccess(cursoconstancia));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}




export function activarSuccess(cursoconstancia) {
  return {type: types.ACTIVAR_CURSOCONSTANCIA_SUCCESS, cursoconstancia};
}


export function activar(id, token) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().CursoConstanciaApi.activar(id, token).then(cursoconstancia => {
               
                  dispatch(activarSuccess(cursoconstancia));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}


export function setFiltro(filtroActivo, filtroActual, showActivos) {
	let filtro={
		filtroActivo,
		filtroActual,
        showActivos
	}
  return {type: types.SET_FILTRO_CURSOCONSTANCIA, filtro};
}



